/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import Bussinessplan from '../../Assets/elvotaimages/Bussinessplan.png';
import Powerd from '../../Assets/elvotaimages/Powerd.png';

const summaryContent1 = [
  'We are an energy trading company committed to driving the energy transition forward. By combining deep market expertise with strategic execution, we create value in increasingly dynamic energy markets.',
  'Our approach focuses on unlocking opportunities while supporting a more flexible and efficient power grid. Through advanced analytics and intelligent trading strategies, we help balance supply and demand in rapidly evolving electricity markets.',
  'A key part of our mission is accelerating the integration of Battery Energy Storage Systems (BESS). By enabling storage assets to participate effectively in energy markets, we help maximize their value while strengthening grid stability.',
  'Through innovation, market insight, and technology, we contribute to building the resilient and sustainable energy markets of tomorrow.',
];

export function ExpertiseIntro() {
  return (
    <div className="main-container">
      <Summary paragraph={summaryContent1} />
    </div>
  );
}

const summaryContent2 = [
  'We combine market intelligence, quantitative analysis, and deep domain knowledge to operate at the heart of modern energy markets. Our work bridges trading performance and strategic advisory, enabling our partners to navigate complexity and unlock long-term value in a rapidly evolving energy landscape.',
];

export default function Expertise() {
  const navigate = useNavigate();
  return (
    <div className="pb-[64px] sm:pb-0  lg:h-[1000px] ">
      <div className="main-container">
        <div>
          <Heading content="Our expertise" />
          <Summary paragraph={summaryContent2} />
        </div>
        <div className="mt-10 xl:mt-0 xl:py-10">
          <div className="grid grid-cols-12 gap-5 lg:gap-10">
            <div className="col-span-12 sm:col-span-6">
              <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                <div className="bg-animated" />
                <div className="z-10 relative">
                  <img src={Powerd} className="w-full h-auto" alt="" />

                  <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                    Energy Storage Trading
                  </h1>
                  <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                    We actively trade energy storage assets across power 
                    markets, to capture value and optimize performance.

                  </p>
                  <div className="col-span-12">
                    <button
                      className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                      onClick={() =>
                        navigate('/solution#operational_services')
                      }
                    >
                      More Info
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6">
              <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                <div className="bg-animated" />
                <div className="z-10 relative">
                  <img
                    src={Bussinessplan}
                    className="w-full h-auto "
                    alt=""
                  />

                  <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                    Energy Storage Consulting
                  </h1>
                  <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                  We support investors, developers, and asset owners in navigating the technical and economic challenges of energy storage projects.


                  </p>
                  <div className="col-span-12">
                    <button
                      className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                      onClick={() => navigate('/solution#advisory_services')}
                    >
                      More Info
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
